import React from 'react'
import { useAtom, useAtomValue } from 'jotai'

import { analyticsCurrentAction, currentStepAtom } from '@store/atoms'
import { trackNavigation } from './trackNavigation'
import { useAppContext } from '@hooks/use-app-context'
import { StepsRichiesta } from '@store/stepsRichiesta'
import { useApi } from '@hooks/use-api-requests.hook'
import { Actions } from '@store/reducer'

export const SatelliteTracker = () => {
	
	const [activeStep] = useAtom(currentStepAtom) //step effettivo della richiesta
	const { state,dispatch } = useAppContext()

	const currentStep = useAtomValue(analyticsCurrentAction) // step navigazione analytics
	const iban = state?.data?.Four?.IBAN
	const codiFiscale = state?.data?.Two?.FiscalCode

	const startingNag = state?.data?.StartingValues?.NAG ?? ''
	const isFinalStep =
		activeStep === StepsRichiesta.RIEPILOGO && currentStep === 'ThankYou' //solo quando praticamente si chiama saveFinalStep POST VIENE SETTATA LA PAGINA SU ANALTICS

	const page = React.useMemo(() => {
		switch (activeStep) {
			case 3:
				return 'Step2'
			case 4:
				return 'Step2'

			case 5:
				// condizione aggiuntiva
				return currentStep === 'ThankYou' ? 'Step4' : 'Step3'

			default:
				return 'UnknownStep'
		}
	}, [activeStep, currentStep])

	//recover nag code if not present in startingvalues so dispatch it in state

	const [nagResponse, fetchNag] = useApi<string >({
		request: 'DbOperations/getNag',
		method: 'POST',
		shouldCache: false,
		sleeper: true,
	})

	React.useEffect(() => {
		if (startingNag?.trim()) return
		if (!iban?.trim()) return
		if (!codiFiscale?.trim()) return

		fetchNag({
			body: {
			iban,
			codiceFiscale: codiFiscale,
		},

		})
	}, [startingNag, iban, codiFiscale])

	const nag = startingNag || nagResponse || ''

	React.useEffect(() => {
		if (!currentStep || currentStep === 'none') return
		if (!iban?.trim()) return
		if (!nag?.trim()) return

		const abi = iban.slice(5, 10)

		trackNavigation({
			name: isFinalStep ? 'invia richiesta' : null,
			pageName: page,
			section: currentStep,
			subsection: 'richiesta',
			bank: `AAA,${abi}`,
			bannerCampaignID: 'interaction_bccOFR451_bccLiveEnvICCREA',
			userId: nag,
			isFinalStep: isFinalStep,
		})
	}, [currentStep, page, iban, nag])


//se il nag non esiste in stargin value e viene recuperato dall'api lo salvo nello state 
	React.useEffect(() => {
	// se già presente non fare nulla
	if (startingNag?.trim()) return

	// se api non ha ancora risposto
	if (!nagResponse?.trim()) return

	dispatch({
		type: Actions.UpdateData,
		payload: {
			StartingValues: {
				...state.data.StartingValues,
				NAG: nagResponse,
			},
		},
	})
}, [nagResponse, startingNag])

	return null
}
